import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home, meta: {
      public: true,
      transition: 'zoom'
  }
  },
  {
    path: '/dashboard/dashboard1',
    name: 'Dashboard1',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Dashboard1.vue')
  } , {
    path: '/dashboard/dashboard2',
    name: 'Dashboard2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dashboard/Dashboard2.vue')
  } ,{
    path: '/exchange/exchange-price',
    name: 'ExchangePrice',
    component: () =>
      import('@/views/exchange/ExchangePrice.vue'),
    meta: {
      breadcrumb: true,

    }
  }, {
    path: '/exchange/exchange-traders',
    name: 'ExchangeTraders',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '@/views/exchange/ExchangeTraders.vue')
  }, {
    path: '/exchange/exchange-transactions',
    name: 'ExchangeTransactions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '@/views/exchange/ExchangeTransactions.vue')
  },{
    path: '/users/profile',
    name: 'Profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/users/Profile.vue')
  } ,{
    path: '/users/api-chat',
    name: 'ApiChat',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/users/ApiChat.vue')
  } ,{
    path: '/users/wallet',
    name: 'Wallet',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/users/Wallet.vue')
  } ,{
    path: '/users/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/users/Settings.vue')
  } ,{
    path: '/markets/market-crypto',
    name: 'MarketCrypto',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/markets/MarketCrypto.vue')
  } ,{
    path: '/markets/market-trade',
    name: 'MarketTrade',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/markets/MarketTrade.vue')
  } ,{
    path: '/others/technical-analysis',
    name: 'TechnicalAnalysis',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/TechnicalAnalysis.vue')
  } ,{
    path: '/others/heat-map',
    name: 'HeatMap',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/HeatMap.vue')
  } ,{
    path: '/others/symbol-info',
    name: 'SymbolInfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/SymbolInfo.vue')
  } ,{
    path: '/others/sign-in',
    name: 'SignIn',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/SignIn.vue'), meta: {
      public: true,
      transition: 'zoom'
  }
  } ,{
    path: '/others/sign-up',
    name: 'SignUp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/SignUp.vue'), meta: {
      public: true,
      transition: 'zoom'
  }
  } ,{
    path: '/others/error404',
    name: 'Error404',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/others/Error404.vue'),meta: {
      public: true,
      transition: 'zoom'
  }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
